angular.module( 'acme.view.application.importExport.exportJobExecution', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.importExport.exportJobExecution.controllers.exportJobExecutionController',
  'acme.view.application.importExport.exportJobExecution.controllers.exportJobExecutionOutputDownloadModalController',
])

  .config(function config( $stateProvider ) {
    var exportJobExecution = {
      name: 'application.importExport.exportJobExecution',
      url: '/job/:jobId/execution/export/:id',
      views: {
        "subview-main": {
          controller: 'ExportJobExecutionController',
          controllerAs: '$ctrl',
          templateUrl: 'views/application/views/importExport/exportJobExecution/exportJobExecution.tpl.html'
        }
      },
      data: {
        pageTitle: 'Import Export - Export Job Execution'
      }
    };

    $stateProvider
      .state(exportJobExecution);
  });
